import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageItem } from '../../core/services/hint-dialog.service';
import { REQUIRED_ERROR_MSG } from '../../core/constants/message.constant';

@Injectable({
  providedIn: 'root',
})
/**
 * 訊息處理工具
 */
export class MessageUtils {
  constructor(private translateService: TranslateService) {}
  /**
   * 於i18n設定檔中尋找key(instant)對應的結果，
   * 並將該結果中的特定字串(searchValue)取代為指定字串(replaceValue)
   * @param instant
   * @param searchValue
   * @param replaceValue
   * @returns
   */
  public messageTranslate = (
    instant: string,
    searchValue: string,
    replaceValue: string
  ) => {
    const str = this.translateService
      .instant(instant)
      .replace(searchValue, replaceValue);
    return str;
  };
  /**
   * FormCluster錯誤訊息處理
   * @param clusterMsgArr formCluster回傳錯誤訊息陣列(getFormClusterValidationErrorMessages)
   * @returns
   */
  public formClusterMsgFactory = (clusterMsgArr: []): MessageItem[] => {
    let useTotalMsg = 0;
    clusterMsgArr.forEach(
      (cluster: { groupName: string; msgList: MessageItem[] }) => {
        const useLength = cluster.msgList?.length ?? 0;
        useTotalMsg = useTotalMsg + useLength;
      }
    );
    let processedMsgList = [] as MessageItem[];
    if (useTotalMsg > 10) {
      clusterMsgArr.forEach(
        (cluster: { groupName: string; msgList: MessageItem[] }) => {
          const errMap: Record<string, { count: number; category: string }> =
            {} as any;
          cluster.msgList.forEach((msg) => {
            if (msg.message?.includes('ADDRESS_')) {
              msg.message = REQUIRED_ERROR_MSG;
            }
            if (msg.message && errMap[msg.message]) {
              errMap[msg.message ?? ''].count =
                errMap[msg.message ?? ''].count + 1;
            } else {
              errMap[msg.message ?? ''] = {
                count: 1,
                category: msg.category ?? '',
              };
            }
          });

          const useCategory = cluster.groupName
            ? this.translateService.instant(cluster.groupName)
            : '';
          Object.keys(errMap).forEach((errKey) => {
            const useMsgItem = {} as MessageItem;
            useMsgItem.category = useCategory;
            useMsgItem.message = `${errKey}{{count}} (${errMap[errKey].count})`;
            processedMsgList.push(useMsgItem);
          });
        }
      );
    } else {
      clusterMsgArr.forEach(
        (cluster: { groupName: string; msgList: MessageItem[] }) => {
          const useCategory = cluster.groupName
            ? this.translateService.instant(cluster.groupName)
            : '';
          cluster.msgList.forEach((msg) => {
            const useMsgItem = {} as MessageItem;
            useMsgItem.category = `${useCategory}/${this.translateService.instant(
              msg.category ?? ''
            )}`;
            useMsgItem.message = msg.message;
            processedMsgList.push(useMsgItem);
          });
        }
      );
    }
    return processedMsgList;
  };
}
